import { SelectOption } from '@/components/elements/select'

export const ageMap: SelectOption[] = [
    { label: 'Niños', value: 'Niños' },
    { label: 'Adultos', value: 'Adultos' },
]
